import {
    LEAGUE_LIST_REQUEST, LEAGUE_LIST_SUCCESS, LEAGUE_LIST_FAIL,
    LEAGUE_DETAILS_REQUEST, LEAGUE_DETAILS_SUCCESS, LEAGUE_DETAILS_FAIL,
    LEAGUE_ACTIVE_REQUEST, LEAGUE_ACTIVE_SUCCESS, LEAGUE_ACTIVE_FAIL,
    LEAGUE_CREATE_REQUEST, LEAGUE_CREATE_SUCCESS, LEAGUE_CREATE_FAIL, LEAGUE_CREATE_RESET,
    LEAGUE_UPDATE_REQUEST, LEAGUE_UPDATE_SUCCESS, LEAGUE_UPDATE_FAIL, LEAGUE_UPDATE_RESET,
    LEAGUE_DELETE_REQUEST, LEAGUE_DELETE_SUCCESS, LEAGUE_DELETE_FAIL,
    LEAGUE_REGISTER_PLAYER_REQUEST, LEAGUE_REGISTER_PLAYER_SUCCESS, LEAGUE_REGISTER_PLAYER_FAIL,
    LEAGUE_REMOVE_PLAYER_REQUEST, LEAGUE_REMOVE_PLAYER_SUCCESS, LEAGUE_REMOVE_PLAYER_FAIL,
    LEAGUE_GENERATE_SCHEDULE_REQUEST, LEAGUE_GENERATE_SCHEDULE_SUCCESS, LEAGUE_GENERATE_SCHEDULE_FAIL,
    LEAGUE_MATCHUP_UPDATE_REQUEST, LEAGUE_MATCHUP_UPDATE_SUCCESS, LEAGUE_MATCHUP_UPDATE_FAIL,
    LEAGUE_MATCHUP_LOCK_REQUEST, LEAGUE_MATCHUP_LOCK_SUCCESS, LEAGUE_MATCHUP_LOCK_FAIL,
    LEAGUE_SCORES_REQUEST, LEAGUE_SCORES_SUCCESS, LEAGUE_SCORES_FAIL,
    LEAGUE_SAVE_SCORE_REQUEST, LEAGUE_SAVE_SCORE_SUCCESS, LEAGUE_SAVE_SCORE_FAIL,
} from '../constants/leagueConstants'

export const leagueListReducer = (state = { leagues: [] }, action) => {
    switch (action.type) {
        case LEAGUE_LIST_REQUEST: return { loading: true, leagues: [] }
        case LEAGUE_LIST_SUCCESS: return { loading: false, leagues: action.payload }
        case LEAGUE_LIST_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}

export const leagueDetailsReducer = (state = { league: null }, action) => {
    switch (action.type) {
        case LEAGUE_DETAILS_REQUEST: return { loading: true, league: null }
        case LEAGUE_DETAILS_SUCCESS: return { loading: false, league: action.payload }
        case LEAGUE_DETAILS_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}

export const leagueActiveReducer = (state = { league: null }, action) => {
    switch (action.type) {
        case LEAGUE_ACTIVE_REQUEST: return { loading: true, league: null }
        case LEAGUE_ACTIVE_SUCCESS: return { loading: false, league: action.payload }
        case LEAGUE_ACTIVE_FAIL:    return { loading: false, error: action.payload }
        case LEAGUE_MATCHUP_UPDATE_SUCCESS:
        case LEAGUE_MATCHUP_LOCK_SUCCESS: {
            if (!state.league) return state
            return {
                ...state,
                league: {
                    ...state.league,
                    matchups: state.league.matchups.map(m =>
                        m.id === action.payload.id ? { ...m, ...action.payload } : m
                    ),
                },
            }
        }
        default: return state
    }
}

export const leagueCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case LEAGUE_CREATE_REQUEST: return { loading: true }
        case LEAGUE_CREATE_SUCCESS: return { loading: false, success: true, league: action.payload }
        case LEAGUE_CREATE_FAIL:    return { loading: false, error: action.payload }
        case LEAGUE_CREATE_RESET:   return {}
        default: return state
    }
}

export const leagueUpdateReducer = (state = {}, action) => {
    switch (action.type) {
        case LEAGUE_UPDATE_REQUEST: return { loading: true }
        case LEAGUE_UPDATE_SUCCESS: return { loading: false, success: true, league: action.payload }
        case LEAGUE_UPDATE_FAIL:    return { loading: false, error: action.payload }
        case LEAGUE_UPDATE_RESET:   return {}
        default: return state
    }
}

export const leagueDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case LEAGUE_DELETE_REQUEST: return { loading: true }
        case LEAGUE_DELETE_SUCCESS: return { loading: false, success: true }
        case LEAGUE_DELETE_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}

export const leagueRegisterPlayerReducer = (state = {}, action) => {
    switch (action.type) {
        case LEAGUE_REGISTER_PLAYER_REQUEST: return { loading: true }
        case LEAGUE_REGISTER_PLAYER_SUCCESS: return { loading: false, success: true, registration: action.payload }
        case LEAGUE_REGISTER_PLAYER_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}

export const leagueRemovePlayerReducer = (state = {}, action) => {
    switch (action.type) {
        case LEAGUE_REMOVE_PLAYER_REQUEST: return { loading: true }
        case LEAGUE_REMOVE_PLAYER_SUCCESS: return { loading: false, success: true }
        case LEAGUE_REMOVE_PLAYER_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}

export const leagueGenerateScheduleReducer = (state = { matchups: [] }, action) => {
    switch (action.type) {
        case LEAGUE_GENERATE_SCHEDULE_REQUEST: return { loading: true, matchups: [] }
        case LEAGUE_GENERATE_SCHEDULE_SUCCESS: return { loading: false, success: true, matchups: action.payload }
        case LEAGUE_GENERATE_SCHEDULE_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}

export const leagueMatchupUpdateReducer = (state = {}, action) => {
    switch (action.type) {
        case LEAGUE_MATCHUP_UPDATE_REQUEST: return { loading: true }
        case LEAGUE_MATCHUP_UPDATE_SUCCESS: return { loading: false, success: true, matchup: action.payload }
        case LEAGUE_MATCHUP_UPDATE_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}

export const leagueMatchupLockReducer = (state = {}, action) => {
    switch (action.type) {
        case LEAGUE_MATCHUP_LOCK_REQUEST: return { loading: true }
        case LEAGUE_MATCHUP_LOCK_SUCCESS: return { loading: false, success: true, matchup: action.payload }
        case LEAGUE_MATCHUP_LOCK_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}

export const leagueScoresReducer = (state = { scores: [] }, action) => {
    switch (action.type) {
        case LEAGUE_SCORES_REQUEST: return { loading: true, scores: [] }
        case LEAGUE_SCORES_SUCCESS: return { loading: false, scores: action.payload }
        case LEAGUE_SCORES_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}

export const leagueSaveScoreReducer = (state = {}, action) => {
    switch (action.type) {
        case LEAGUE_SAVE_SCORE_REQUEST: return { loading: true }
        case LEAGUE_SAVE_SCORE_SUCCESS: return { loading: false, success: true, score: action.payload }
        case LEAGUE_SAVE_SCORE_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}
